"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: ", ";\n  top: 0;\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  padding-top: ", "%;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function calcPadding(_ref) {
  var isReady = _ref.isReady,
      placeholderAspectRatio = _ref.placeholderAspectRatio;
  return isReady ? '0' : (100 / placeholderAspectRatio).toFixed(2).toString();
}

var Padding = _styledComponents.default.div.withConfig({
  displayName: "Wrapper__Padding",
  componentId: "ef3i7p-0"
})(_templateObject(), calcPadding, function (props) {
  return props.loadingBackground || '';
});

var Container = _styledComponents.default.div.withConfig({
  displayName: "Wrapper__Container",
  componentId: "ef3i7p-1"
})(_templateObject2(), function (props) {
  return props.isReady ? 'relative' : 'absolute';
});

var _default = function _default(props) {
  return _react.default.createElement(Padding, props, _react.default.createElement(Container, {
    isReady: props.isReady
  }, props.children));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/components/StyledComponents/Wrapper.js
// module id = 276
// module chunks = 0